/* KNM-136 (folio): детальная бронь с посуточным folio — нужна для режима редактирования. */
import { QuoteDay } from './quote'
import { ReservationPayment } from './payments'


export type ReservationDiscount = {
  type: 'percent' | 'flat' | null
  value: string | null
  amount: string
  comment: string | null
}

export type ReservationDetailRes = {
  pk: number
  accomodation: number
  room: number | null
  room_category: number | null
  rate_plan: number | null
  rate_plan_name: string | null
  cost_enabled: boolean
  checkin_date: string
  checkout_date: string
  checkin_time: string
  checkout_time: string
  adults: number
  children: number
  contact_person: string | null
  phone: string | null
  email: string | null
  source: number
  source_name: string
  status: string
  status_slug: string
  notes: string | null
  reservation_tag: number | null
  days: (QuoteDay & { price_comment: string | null, line_total: string })[]
  discount: ReservationDiscount
  accommodation_subtotal: string
  balance: string
  payments: ReservationPayment[]
  capacity: {
    person_qty: number
    extra_person_qty: number
    max_capacity: number
  } | null
}

export const GET_RESERVATION_DETAIL_URL = '/v2/pms/reservations/:pk/'
